import React from 'react';
import { Grid, Rating } from '@mui/material';

const StarRatingControl = ({ rate, setRate, isReadOnly }) => (
  <Grid display="flex" alignItems="center" justifyContent="flex-start" pb="16px">
    <Rating
      style={{ direction: 'ltr', cursor: 'pointer' }}
      size="large"
      name="simple-controlled"
      value={rate}
      onChange={(event, newValue) => setRate(newValue)}
      sx={{
        '& .MuiRating-icon': {
          fontSize: '40px',
          width: '40px',
          height: '40px',
          margin: '0 4px',
        },
        '& .MuiRating-iconEmpty': {
          fontSize: '40px',
          width: '40px',
          height: '40px',
          margin: '0 4px',
        },
      }}
    />
  </Grid>
);

export default StarRatingControl;
